// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"+KjXq","rc-tabs-tab-active":"f47Va","input-suffix":"ziIOe","nav-item":"_5hkR8","background":"GA4sr","confirm":"_8a6lN","dialogue":"olhki"};